export default __webpack_public_path__ + "static/media/ic-students.86e43f29.svg";